import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter } from "lucide-react";
import Logo from "./Logo";

const CONTACT_LINKS = [
  { label: "Selling an agency", to: "/contact?path=agency-sale", testid: "footer-agency" },
  { label: "Selling a portfolio", to: "/contact?path=portfolio-sale", testid: "footer-portfolio" },
  { label: "Lending enquiries", to: "/contact?path=lending", testid: "footer-lending" },
  { label: "Careers", to: "/contact?path=careers", testid: "footer-careers" },
  { label: "General enquiries", to: "/contact?path=general", testid: "footer-general" },
];

const NAV_LINKS = [
  { label: "Agency Acquisitions", to: "/agency-acquisitions" },
  { label: "Property Portfolios", to: "/property-portfolios" },
  { label: "Our Brands", to: "/our-brands" },
  { label: "About", to: "/about" },
  { label: "Careers", to: "/careers" },
  { label: "Contact", to: "/contact" },
];

const Footer = () => {
  return (
    <footer className="bg-navy text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Logo variant="light" />
            <p className="mt-6 text-sm leading-relaxed text-steel-light max-w-xs">
              A UK holding company acquiring and holding established letting and estate agencies and
              residential property portfolios for the long term.
            </p>
          </div>

          {/* Navigate */}
          <div>
            <h4 className="text-xs tracking-kicker uppercase text-steel-light mb-5">Navigate</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact paths */}
          <div>
            <h4 className="text-xs tracking-kicker uppercase text-steel-light mb-5">Enquiries</h4>
            <ul className="space-y-3">
              {CONTACT_LINKS.map((l) => (
                <li key={l.testid}>
                  <Link
                    to={l.to}
                    data-testid={l.testid}
                    className="text-sm text-white/80 hover:text-white transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Registered details */}
          <div>
            <h4 className="text-xs tracking-kicker uppercase text-steel-light mb-5">Registered office</h4>
            <address className="not-italic text-sm text-white/80 leading-relaxed space-y-1">
              <p>OTP Group Holdings Limited</p>
              <p>Unit B04 Acton Business Centre</p>
              <p>London</p>
              <p>NW10 6TD, United Kingdom</p>
              <p className="pt-2 text-steel-light">Company reg. no. 11726488</p>
            </address>
            <div className="mt-6 flex items-center gap-4">
              <a href="#" aria-label="LinkedIn" className="text-steel-light hover:text-white transition-colors" data-testid="social-linkedin">
                <Linkedin size={18} />
              </a>
              <a href="#" aria-label="X" className="text-steel-light hover:text-white transition-colors" data-testid="social-twitter">
                <Twitter size={18} />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-steel-light">
            © {new Date().getFullYear()} OTP Group Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-steel-light">
            <a href="#" className="hover:text-white transition-colors">Privacy</a>
            <a href="#" className="hover:text-white transition-colors">Terms</a>
            <a href="#" className="hover:text-white transition-colors">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
